import { render, staticRenderFns } from "./TdReasonType.vue?vue&type=template&id=14c63ee5&"
import script from "./TdReasonType.vue?vue&type=script&lang=ts&"
export * from "./TdReasonType.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports